import { FC } from 'react'

import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import * as SC from '../../style'
import { Props } from './Props'

export const ReviewWireActivityForTransactionsWireActivity: FC<Props> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <SC.SecondText>
          Review the wire activity noting the location of the originator/beneficiary and for unknown merchant/vendor
          activity.
        </SC.SecondText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewWireActivityForTransactionsWireActivity"
          label="Was there international or unknown merchant/vendor activity?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'Yes – See comments',
                value: 'yes'
              },
              {
                label: 'All Transactions Ok',
                value: 'all_transactions'
              },
              {
                label: 'No Transactions of this Type',
                value: 'no_transactions'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Col>
          <Field
            name="reviewWireActivityForTransactionsActivityAddressed"
            label=" If noted, how was the activity addressed?"
            input={Select}
            inputProps={{
              data: [
                {
                  label: 'N/A',
                  value: 'n/a'
                },
                {
                  label: 'Transactions cleared with communication to customer during review',
                  value: 'cleared'
                },
                {
                  label: 'Transactions added to Annual Review questions',
                  value: 'added'
                }
              ]
            }}
          />
        </Col>
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewWireActivityForTransactionsComment"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
